import { registerCashOperation } from './registerCashOperation';
import { Permission } from 'core/api';
import { Preconditions } from 'core/infrastructure-next';
import { Command } from 'pos/common';

declare global {
	interface CommandType {
		registerInputCahsOperation: () => Promise<Result>
	}
}

Command.register('registerInputCahsOperation', Preconditions.and(Preconditions.ensure(Permission.Cashdrawer_RegisterInputCashTransaction), Preconditions.ensureSlaveCanHandleCashOperations), () => registerCashOperation('INPUT'));
